<template>
  <div class="isolated-video">
    <div v-show="!isComponentLoading" class="isolated-video__wrapper">
      <div :id="localId"></div>
    </div>
    <div v-show="isComponentLoading" class="isolated-video__spinner-wrapper">
      <ActionLoader loaderClass="isolated-video__spinner" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import uuid from 'uuid/v4'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import { kinesisCommons, videoCommons } from '@/helpers/mixins'

export default {
  name: 'IsolatedVideo',
  components: {
    ActionLoader,
  },
  mixins: [kinesisCommons, videoCommons],
  props: {
    videoId: {
      type: String,
      required: true,
    },
    autostart: {
      type: Boolean,
      required: false,
      default: () => {
        return false
      },
    },
    trigger: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      isComponentLoading: false,
      localId: `u${uuid()}`,
      videoFetched: null,
    }
  },
  computed: {
    ...mapState({
      profile: state => state.auth.userProfile,
      course: state => state.courses.currentCourse,
    }),
  },
  async created() {
    this.setIsComponentLoading = true
    const response = await this.$store.dispatch(
      'content/getJWVideo',
      this.videoId
    )
    this.videoFetched = await this.$store.dispatch(
      'content/getVideoStatus',
      this.videoId
    )
    const { playlist: sources } = response
    if (sources) {
      this.setupPlayer(sources)
      const isVideoCompleted =
        this.videoFetched?.current_position_in_secs ===
        this.videoFetched.duration_in_seconds
      if (isVideoCompleted) {
        this.$store.dispatch('content/updateVideoPosition', {
          videoId: this.videoId,
          position: 0,
        })
      }
      if (process.env.VUE_APP_RESUME_VIDEO_ENABLED) {
        const videoPosition = isVideoCompleted
          ? 0
          : this.videoFetched?.current_position_in_secs
        this.instance?.seek(videoPosition)
      }
    } else {
      this.$emit('close-video-player')
    }
    this.setIsComponentLoading = false
    this.sendMixpanelEvent(this.eventsConstants.CONTENT_VIDEO_MEDIA_REQUESTED, {
      course_id: this.course.id,
      course_name: this.course.name,
      video_id: this.videoId,
      video_name: this.videoFetched.name,
      trigger: this.trigger,
      ...this.videoFetched,
    })
  },
  destroyed() {
    if (this.instance) this.instance.remove()
  },
}
</script>

<style lang="scss" scoped>
.isolated-video {
  &__wrapper {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    top: 15%;
    margin: 0px auto;
    background-color: var(--light-gray);
    color: var(--white);
  }
  &__spinner-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
